import React, { useMemo } from 'react';
import { Link } from 'react-router-dom';

import { useReference } from '../../util/references/ModelReference';
import { contentSourceReference } from '../../util/references/ContentSourceReference';
import { ContentSourceReferenceDescriptor } from '~/util/references/ContentSourceReference';

export interface ContentSourceLinkProps {
  reference: ContentSourceReferenceDescriptor;
}

export function getContentSourceUrl( id: number ): string {
  return `/content/sources/${id}`;
}

export const ContentSourceLink: React.FC<ContentSourceLinkProps> = ( { reference: descriptor } ) => {
  const reference = useMemo( () => contentSourceReference( descriptor ), [descriptor] );
  const { model, error } = useReference( reference );
  const url = getContentSourceUrl( reference.id );

  return (
    <>
      { error && <span>{ error.message }</span> }
      { !error && !model && <Link to={ url }>Content Source #${ reference.id }</Link> }
      { model && <Link to={ url }>{ model.name }</Link> }
    </>
  );
};

ContentSourceLink.displayName = 'ContentSourceLink';
